export default "__VITE_ASSET__CmXxzk3x__"